import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Col, Row, Form, Button} from 'react-bootstrap';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-multi-date-picker"
import opacity from "react-element-popper/animations/opacity"
import thai from "../../../components/Utils/DatePicker/thai"
import thai_th from "../../../components/Utils/DatePicker/thai_th"
import StudentCourseService from '../../../service/studentCourseService';
import { successNotify, errorNotify } from '../../../components/Utils/Toast';
import ReactTooltip from 'react-tooltip';
import useToken from '../../../App/useToken';
import 'react-toastify/dist/ReactToastify.css';
import './StudentCourse.css';

function ConfirmationStudentCourse() {
  const { getToken, isAdmin } = useToken();
  const { course_name, airforce_id } = useParams();
  const token = getToken();
  const isUseAdmin = isAdmin();
  const [terms, setTerms] = useState([]);
  const [studentData, setStudentData] = useState();
  const [termChoices, setTermChoices] = useState([]);
  const [studentTermRequest, setStudentTermRequest] = useState();

  const getStudentCourseInfo = async () => {
    const studentCourseService = new StudentCourseService();
    const res = await studentCourseService.getStudentCourseConfirmationByCourseNameAndAirforceId(course_name, airforce_id, token);
    setStudentData(res.studentData);
    setTerms(res.terms);
  }

  useEffect(() => {
    getStudentCourseInfo();
  }, []);

  useEffect(() => {
    const termTemp = [];
    terms.map((term, index) => {
      if (index != 0) {
        termTemp.push({ value: index, label: `รุ่นที่ ${term.id}` });
      }
    })
    setTermChoices(termTemp);
    setStudentTermRequest(termTemp[0]?.value)
  }, [terms]);

  const handleSubmit = async e => {
    e.preventDefault();
    const studentCourseService = new StudentCourseService();
    studentCourseService.updateStudentCourseTermChose(studentData._id, { term: studentTermRequest }, token).then(data => {
      successNotify('แก้ไขข้อมูลสำเร็จ');
    });
    
  }


  return (
    <div>
      <Container className='student-wrapper'>
        <ReactTooltip />
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ชื่อ:</Form.Label>
                <Form.Control value={`${studentData?.rankAbbrName}${studentData?.fullName}`} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>อายุ:</Form.Label>
                <Form.Control value={studentData?.age} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>เหล่า:</Form.Label>
                <Form.Control value={studentData?.pme_data?.ARM_ABBR_NAME || '-'} disabled />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ระยะเวลาครองยศปัจจุบัน:</Form.Label>
                <Form.Control value={studentData?.seniorOfRank} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ตำแหน่ง:</Form.Label>
                <Form.Control value={studentData?.pme_data?.POS_ORG_ABBR_NAME || '-'} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>สังกัด:</Form.Label>
                <Form.Control value={studentData?.pme_data?.ORG_ABBR_NAME} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>สายวิทยาการ:</Form.Label>
                <Form.Control value={studentData?.spcName} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ระบุแผนอัตราการเข้าของหน่วย:</Form.Label>
                <Form.Control disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">

            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>คะแนนประเมินล่าสุด:</Form.Label>
                <Form.Control disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ลชทอ.หลัก:</Form.Label>
                <Form.Control value={studentData?.pme_data?.SKILL_NO_01 || '-'} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ลชทอ.รอง1:</Form.Label>
                <Form.Control value={studentData?.pme_data?.SKILL_NO_02 || '-'} disabled />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ลชทอ.รอง2:</Form.Label>
                <Form.Control value={studentData?.pme_data?.SKILL_NO_03 || '-'} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group as={Col} controlId="name">
                <Form.Label>ผลสอบภาษาอังกฤษ:</Form.Label>
                <Form.Control disabled />
              </Form.Group>
            </Col>
          </Row>
          <hr />
          {terms.map((term, index) => (
            <Col md={6}>
              <Row className='term-container'>
                { (index != 0) && 
                  <>
                    <Col md={2}>
                      <Form.Group as={Col} controlId="name">
                        <Form.Label>รุ่นที่:</Form.Label>
                        <Form.Control value={term.id} disabled />
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group as={Col}>
                      <Form.Label>วันเข้ารับการศึกษา</Form.Label><br />
                      <DatePicker 
                          inputClass='form-control'
                          // calendar={thai} 
                          locale={thai_th} 
                          required
                          format='DD/MMMM/YYYY'
                          animations={[opacity()]} 
                          value={term.stardTermPeriod}
                          disabled
                      />
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group as={Col}>
                      <Form.Label>วันเข้าจบการศึกษา</Form.Label><br />
                      <DatePicker 
                          inputClass='form-control'
                          // calendar={thai} 
                          locale={thai_th} 
                          required
                          format='DD/MMMM/YYYY'
                          animations={[opacity()]} 
                          value={term.endTermPeriod}
                          disabled
                      />
                      </Form.Group>
                    </Col>
                  </>
                }
              </Row>
            </Col>
          ))}
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>มีความประสงค์จะเข้ารับการศึกษา: </Form.Label>
                <Form.Control required as="select" custom onChange={e => setStudentTermRequest(e.target.value)}>
                  {termChoices.map(termChoice => (
                    <option value={termChoice.value}>{termChoice.label}</option>
                  ))}
                  
                </Form.Control>
              </Form.Group> 
            </Col>
          </Row>
          <Button variant="primary" type='submit'>บันทึก</Button>
        </Form>
      </Container>
    </div>
  )
};


export default ConfirmationStudentCourse;
